import { PERMISSIONS, type Permission } from '@/types';

export const mockPermissions: Permission[] = [
  {
    key: PERMISSIONS.DASHBOARD_VIEW,
    name: 'View Dashboards',
    description: 'View dashboards',
    category: 'Dashboards',
  },
  {
    key: PERMISSIONS.DASHBOARD_EDIT,
    name: 'Edit Dashboards',
    description: 'Edit dashboards',
    category: 'Dashboards',
  },
  {
    key: PERMISSIONS.DASHBOARD_DELETE,
    name: 'Delete Dashboards',
    description: 'Delete dashboards',
    category: 'Dashboards',
  },
  {
    key: PERMISSIONS.WIDGET_CREATE,
    name: 'Create Widgets',
    description: 'Add widgets',
    category: 'Widgets',
  },
  {
    key: PERMISSIONS.WIDGET_EDIT,
    name: 'Edit Widgets',
    description: 'Modify widgets',
    category: 'Widgets',
  },
  {
    key: PERMISSIONS.WIDGET_DELETE,
    name: 'Delete Widgets',
    description: 'Remove widgets',
    category: 'Widgets',
  },
  {
    key: PERMISSIONS.REPORTS_VIEW,
    name: 'View Reports',
    description: 'View reports',
    category: 'Reports',
  },
  {
    key: PERMISSIONS.USERS_MANAGE,
    name: 'Manage Users',
    description: 'Manage users',
    category: 'Admin',
  },
  {
    key: PERMISSIONS.ROLES_MANAGE,
    name: 'Manage Roles',
    description: 'Manage roles',
    category: 'Admin',
  },
  {
    key: PERMISSIONS.AUDIT_VIEW,
    name: 'View Audit Logs',
    description: 'View audit logs',
    category: 'Admin',
  },
  {
    key: PERMISSIONS.SETTINGS_MANAGE,
    name: 'Manage Settings',
    description: 'Change app settings',
    category: 'Admin',
  },
];
